import 'select2'

$(document).on('turbo:load', function() {
  $('.js-select-multi').select2({
    multiple: true
  })
})
